import React, {useContext} from 'react';
import HeartFilled from '../../assets/images/Happily-Ever-After-Icons-Heart-filled.png';
import HeartEmpty from '../../assets/images/Happily-Ever-After-Icons-Heart.png';
import './progress.scss';
import ReactTooltip from 'react-tooltip'
import PropTypes from "prop-types";
import {Link} from 'react-router-dom';
import {TourContext} from "../../contexts/TourContext";

const CoreCategory = ({...props}) => {
    const {state} = useContext(TourContext)
    // console.log('bring on the Core Props: ', props)

    const taskCompleted = (heart) => {

        if (heart) {
            return (
                <img alt="action-completed" className="heart-icon" src={HeartFilled}/>
            )
        }
        return (
            <img alt="action-incomplete" className="heart-icon" src={HeartEmpty}/>
        )
    }


    const createLink = (dest, name) => {
        return state.isOpen ? name : <Link to={'/section/' + dest.split(' ').join('-')}>{name}</Link>
    }
    const createHeartLink = (name) => {
        return '/section/' + name.split(' ').join('-');
    }

    const redirectAction = (e) => {
        let classList = e.currentTarget.className.split(' ');
        if (!state.isOpen) {
            if (classList.includes('watched')) {
                return !props.heartWatched ? props.history.push(`${createHeartLink(props.coreCategoryTitle)}?a=w`) : null;
            }
            if (classList.includes('reviewed')) {
                return !props.heartReviewed ? props.history.push(`${createHeartLink(props.coreCategoryTitle)}?a=r`) : null;
            }
            if (classList.includes('learned')) {
                return !props.heartLearned ? props.history.push(`${createHeartLink(props.coreCategoryTitle)}?a=l`) : null;
            }
        } else {

        }

    }


    return (
        <div className="core-category" data-tut="reactour__title">

            <ReactTooltip place="top" type="warning" effect="solid"/>

            <div className="image-container">

                <img alt="category-icon" src={
                    state.currentStep === 8 && props.index === 0 ? props.iconsTitle.imgFilled
                        : props.icon
                }/>

            </div>
            <div className={`core-category-title ${props.pulseTitle ? 'pulse' : ''}`}>
                {createLink(props.coreCategoryTitle, props.coreCategoryTitle)}
            </div>

            <div className="core-completed-list">
                <ul className="hearts-container" data-tut="reactour__hearts-container">
                    <li className="heart-icon">
                        <div className="heart-icon-container watched" data-tip="watch video"
                             onClick={redirectAction.bind(this)}>
                            {
                                state.currentStep === 8 && props.index === 0 ? taskCompleted(true)
                                    : taskCompleted(props.heartWatched)
                            }
                        </div>
                    </li>
                    <li className="heart-icon">
                        <div className="heart-icon-container reviewed" data-tip="review pdf"
                             onClick={redirectAction.bind(this)}>
                            {

                                state.currentStep === 8 && props.index === 0 ? taskCompleted(true) :
                                    taskCompleted(props.heartReviewed)

                            }
                        </div>
                    </li>
                    <li className="heart-icon">
                        <div className="heart-icon-container learned" data-tip="click learn"
                             onClick={redirectAction.bind(this)}>
                            {

                                state.currentStep === 8 && props.index === 0 ? taskCompleted(true) :
                                    taskCompleted(props.heartLearned)

                            }
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    );


}

CoreCategory.propTypes = {
    pulseTitle: PropTypes.bool,
    coreCategoryTitle: PropTypes.string,
    heartWatched: PropTypes.bool,
    heartReviewed: PropTypes.bool,
    heartLearned: PropTypes.bool,
    icon: PropTypes.string
};

export default CoreCategory;